import React from "react";
import {connect} from "react-redux";

import Fade from "@mui/material/Fade";
import LookAILoadingBar from "./LookAILoadingBar";


const LookAILoadingPanel = ({aiLoading}) => {
  return (
    <Fade in={aiLoading} timeout={300} unmountOnExit>
      <div className="fixed u-left-1/2 -translate-x-1/2 u-bottom-25 u-w-full" style={{
        maxWidth: "340px",
        zIndex: 40,
      }}>
        <LookAILoadingBar className="bg-white/50 shadow-lg"/>
      </div>
    </Fade>
  );
}


const mapStateToProps = (store) => {
  const {aiLoading} = store.aiState;
  return {
    aiLoading,
  };
};

export default connect(mapStateToProps)(LookAILoadingPanel)
